import { configureStore } from "@reduxjs/toolkit";
import React from "react";
import * as ReactDOMClient from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import { GraphQLProvider } from "./context/GraphQLProvider";
import { ReactQueryDevtools } from "react-query/devtools";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "react-tippy/dist/tippy.css";
import "react-toastify/dist/ReactToastify.css";
import "swiper/css/bundle";
import App from "./App";
import { AuthProvider } from "./context/AuthProvider";
import "./index.css";
import combineReducers from "./Redux/RootReducer";
// PrimeReact CSS imports - ensure proper order and all necessary styles
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
// Additional PrimeReact component styles
// import "primereact/resources/primereact.css";
// import "primereact/resources/themes/lara-light-blue/theme.css";

const store = configureStore({
  reducer: combineReducers,
  devTools: process.env.NODE_ENV !== 'production',
});
const queryClient = new QueryClient();
const root = ReactDOMClient.createRoot(document.getElementById("root"));
root.render(
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Provider store={store}>
          <AuthProvider>
            <GraphQLProvider>
              <Routes>
                <Route path="/*" element={<App />} />
              </Routes>
            </GraphQLProvider>
          </AuthProvider>
        </Provider>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
    </QueryClientProvider>
);
